import { getIconProps, type IconProps } from '#types'

/**
 * Key icon — bow circle with shaft and teeth.
 *
 * Used for access codes, key-related affordances, and authentication
 * flows. Visually identical to {@link LockIcon} — see DEPRECATED.md.
 */
export function KeyIcon({ strokeWidth = 2, ...props }: IconProps) {
  return (
    <svg {...getIconProps(props)} viewBox="0 0 24 24">
      <path
        d="M10.6215 12.1638C12.1363 13.7277 12.1363 16.2632 10.6215 17.8271C9.10674 19.391 6.65083 19.391 5.13607 17.8271C3.62131 16.2632 3.62131 13.7277 5.13607 12.1638C6.65083 10.5999 9.10674 10.5999 10.6215 12.1638ZM10.6215 12.1638L16.4498 6.14661C16.6392 5.95113 16.9462 5.95113 17.1355 6.14661L18.8497 7.91639M14.05 8.62444L15.5 10.0745"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  )
}
